import { DataModel, core, } from "@essenza/react";

export function SportModel() {
    DataModel.call(this);
}

core.prototypeOf(DataModel, SportModel, {
    etype: "sport",
});